export default [
  {
    path: '/labels',
    name: 'labels',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'label',
          actions: ['list-all'],
        },
      ],
    },
    // route level code-splitting
    component: () =>
      import( '../../views/labels/Index'),
  },
  {
    path: '/labels/:id(\\d+)',
    name: 'label-details',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'label',
          actions: ['view'],
        },
      ],
    },
    // route level code-splitting
    component: () =>
      import(
         '../../views/labels/Single'
      ),
  },
];
